import script from "./TransactionMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionMessage.vue?vue&type=script&lang=ts&setup=true"

import "./TransactionMessage.vue?vue&type=style&index=0&id=44dc5de2&lang=scss"

const __exports__ = script;

export default __exports__